// src/components/PricingSection.tsx
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ArrowLeftIcon, Check } from "lucide-react";
import { ManualPaymentDialog } from "./ManualPaymentDialog";

const plans = [
  {
    name: "Arranque",
    price: "Gratis",
    description: "Ideal para comenzar sin complicaciones",
    features: [
      "Hasta 3 cuentas",
      "Balance diario y mensual",
      // "Tips de inversión y diversificación	",
      //   "Basic analytics",
      //   "Community support",
      //   "2GB storage",
      //   "API access",
    ],
    popular: false,
  },
  {
    name: "Impulso",
    price: "S/10",
    description: "Para usuarios que buscan escalar",
    features: [
      "Hasta 10 cuentas",
      "Balance ilimitado",
      "Reporte CSV diario, mensual y anual",
      // "Tips de inversión y diversificación	",
    ],
    popular: false,
  },
  {
    name: "Visión",
    price: "S/15",
    description: "Análisis profundo, proyección, control",
    features: [
      "Cuentas ilimitadas",
      "Balance ilimitado",
      "Reporte PDF, CSV mensual, anual, diario",
      "Bot IA, registra desde whatsapp (Proximamente)",
      "Notificaciones de pago de tarjeta de crédito (Proximamente)",
    ],
    popular: true,
  },
];

export function PricingSection() {
  return (
    <div className="py-12 px-6 max-w-6xl mx-auto  ">
      <h2 className="text-4xl font-bold mb-2">
        con estos planes Unifica tus{" "}
        <span className="bg-yellow-200 px-2">finanzas</span>
      </h2>
      <p className="text-muted-foreground mb-10">
        Lleva un control más detallado de todas tus cuentas en un solo lugar
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {plans.map((plan) => (
          <Card
            key={plan.name}
            className={`relative ${
              plan.popular ? "border-2 border-black" : ""
            }`}
          >
            {plan.popular && (
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-black text-white text-xs px-2 py-1 rounded shadow">
                Más popular
              </div>
            )}
            <CardHeader>
              <CardTitle className="text-2xl font-semibold">
                {plan.name}
              </CardTitle>
              <div className="text-4xl font-bold">
                {plan.price} <span className="text-base font-normal">/mes</span>
              </div>
              <p className="text-sm text-muted-foreground mt-2">
                {plan.description}
              </p>
            </CardHeader>
            <CardContent className="space-y-2">
              <ul className="text-sm text-left   list-inside">
                {plan.features.map((feature, i) => (
                  <li key={i} className="flex">
                    <Check />
                    {feature}
                  </li>
                ))}
              </ul>
              <div className="mt-4">
                {plan.price !== "Gratis" && (
                  <ManualPaymentDialog></ManualPaymentDialog>
                )}
                {/* <Button className={"w-full  text-white"}>Adquirir plan</Button> */}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
